<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal id="form-attachment-upload-files" :state="state" backdrop hideable
    @hide="$emit('hide')" @shown="focusLink">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <i18n tag="p" path="introduction[0].full">
          <template #dragAndDrop>
            <strong>{{ $t('introduction[0].dragAndDrop') }}</strong>
          </template>
        </i18n>
        <i18n tag="p" path="introduction[1].full">
          <template #clickHere>
            <input v-show="false" ref="input" type="file" multiple>
            <a ref="link" href="#" role="button" @click.prevent="clickInput">
              <span class="icon-folder-open"></span>
              <span>{{ $t('introduction[1].clickHere') }}</span>
            </a>
          </template>
        </i18n>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-primary" @click="$emit('hide')">
          {{ $t('action.ok') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';

export default {
  name: 'FormAttachmentUploadFiles',
  components: { Modal },
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Using a jQuery event handler rather than a Vue one in order to facilitate
    // testing: it is possible to mock a jQuery event but not a Vue event.
    $(this.$refs.input).on('change.form-attachment-upload-files', (event) =>
      this.$emit('select', event.target.files));
  },
  beforeDestroy() {
    $(this.$refs.input).off('.form-attachment-upload-files');
  },
  methods: {
    focusLink() {
      $(this.$refs.link).focus();
    },
    clickInput() {
      $(this.$refs.input).click();
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Upload Files",
    "introduction": [
      {
        "full": "To upload files, you can {dragAndDrop} one or more files onto the table on this page.",
        "dragAndDrop": "drag and drop"
      },
      {
        "full": "If you would rather select files from a prompt, ensure that their names match the ones in the table and then {clickHere}.",
        "clickHere": "click here to choose"
      }
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Nahrát soubory",
    "introduction": [
      {
        "full": "Chcete-li nahrát soubory, můžete {dragAndDrop} do tabulky na této stránce jeden nebo více souborů.",
        "dragAndDrop": "přetáhněte soubory sem"
      },
      {
        "full": "Pokud byste raději vybrali soubory z příkazového řádku, zajistěte, aby se jejich názvy shodovaly se jmény v tabulce a poté {clickHere}.",
        "clickHere": "kliknutím vyberte"
      }
    ]
  },
  "de": {
    "title": "Dateien hochladen",
    "introduction": [
      {
        "full": "Um Dateien hochzuladen, können Sie eine oder mehrere Dateien mit {dragAndDrop} in die Tabelle auf dieser Seite ziehen.",
        "dragAndDrop": "Drag-and-Drop"
      },
      {
        "full": "Wenn Sie Dateien lieber über eine Eingabeaufforderung auswählen, stellen Sie sicher, dass die Namen denen in der Tabelle entsprechen und {clickHere}.",
        "clickHere": "klicken Sie hier"
      }
    ]
  },
  "es": {
    "title": "Subir archivos",
    "introduction": [
      {
        "full": "Para cargar archivos, puede {dragAndDrop} uno o más archivos en la tabla de esta página.",
        "dragAndDrop": "arrastrar y soltar"
      },
      {
        "full": "Si prefiere seleccionar archivos de una solicitud, asegúrese de que sus nombres coincidan con los de la tabla y luego {clickHere}.",
        "clickHere": "haga clic aquí para elegir"
      }
    ]
  },
  "fr": {
    "title": "Téléverser des fichiers",
    "introduction": [
      {
        "full": "Pour téléverser des fichiers, vous pouvez {dragAndDrop} un ou plusieurs fichiers sur le tableau de cette page..",
        "dragAndDrop": "Glisser et déposer"
      },
      {
        "full": "Si vous préférez naviguer vers les fichiers à sélectionner, assurez vous que leurs noms correspondent à ceux mentionnés dans le tableau et {clickHere}.",
        "clickHere": "Cliquez ici pour choisir"
      }
    ]
  }
}
</i18n>
